import React from 'react';
import './ChampionHeader.css';
import { useChampionDisplayNames } from '../../utils/championNames';

interface ChampionHeaderProps {
  championName: string;
  championImageUrl: string;
  championTitle?: string;
  championData?: {
    play_count: number;
    win_rate_pct: number;
  };
}

const ChampionHeader: React.FC<ChampionHeaderProps> = ({ 
  championName, 
  championImageUrl, 
  championTitle,
  championData 
}) => {
  const { getDisplayName } = useChampionDisplayNames();

  return (
    <div className="ch-champion-header">
      <img src={championImageUrl} alt={getDisplayName(championName)} className="ch-champion-avatar" />
      <div className="ch-champion-info">
        <div className="ch-champion-name-container">
          <h1 className="ch-champion-name">{getDisplayName(championName)}</h1>
          {championTitle && <span className="ch-champion-title">{championTitle}</span>}
        </div>
        <div className="ch-champion-stats">
          {championData && (
            <>
              <div className="ch-champion-stat">Games: {championData.play_count}</div>
              <div className="ch-champion-stat">Win Rate: {championData.win_rate_pct}%</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChampionHeader; 